/* global listingData */
/* global listingPrices */
/* global noUiSlider */
/* global jQuery */

import Vue from 'vue';
import queryString from 'query-string';
import isEmpty from 'lodash/isEmpty';
import trimStart from 'lodash/trimStart';
import startsWith from 'lodash/startsWith';
import { toggleAttribute } from './helpers';
import Paginate from 'vuejs-paginate';

// Add the pagination component
Vue.component('paginate', Paginate, {
	// pass totalPages as a prop from the main Vue instance
	props: ['totalPages']
});

let listingCollection = {};
let totalPages;
let allResults;

const handleFilterUpdates = function( data ){

	var newOption, i;

	if ( 'undefined' === typeof data ) {
		return;
	}

	// Handle Price Updates
	if ( data.mileage && 'undefined' !== typeof data.price ) {
		var minPrice = 'undefined' !== typeof data.price[0] ? data.price[0] : 1;
		var maxPrice = 'undefined' !== typeof data.price[1] ? data.price[1] : 20000;
		var price_filter = document.getElementById('zablisting_price_filter');
		if ( ! isEmpty( price_filter ) ) {
			price_filter.noUiSlider.updateOptions( {
				start: [ data.price[0], data.price[1] ],
				range: {
					'min': [ minPrice ],
					'max': [ maxPrice ]
				},
				step: 1000,
			} );
			document.getElementById( 'zablisting_price_filter_indicator' ).innerText = 'R' + minPrice + ' - ' + 'R' + maxPrice;
		}
	}

	// Handle Mileage Updates
	if ( data.mileage && 'undefined' !== typeof data.mileage ) {
		var mileage_slider = document.getElementById( 'zablisting_mileage_filter' );
		if ( ! isEmpty( mileage_slider ) ) {
			mileage_slider.noUiSlider.updateOptions( {
				start: [ data.mileage[0], data.mileage[1] ],
				range: {
					'min': [ data.mileage[0] ],
					'max': [ data.mileage[1] ]
				},
			} );
			document.getElementById( 'zablisting_mileage_filter_indicator' ).innerText = data.mileage[0] + 'km - ' + data.mileage[1] + 'km';
		}
	}

	// Handle Model Year Updates
	if ( data.years && 'undefined' !== typeof data.years ) {
		var year_slider = document.getElementById( 'zablisting_year_filter' );
		if ( ! isEmpty( year_slider ) ) {
			year_slider.noUiSlider.updateOptions( {
				start: [ parseInt(data.years[0]), parseInt(data.years[1]) ],
				range: {
					'min': [ parseInt(data.years[0]) ],
					'max': [ parseInt(data.years[1]) ]
				},
			} );
			document.getElementById( 'zablisting_year_filter_indicator' ).innerText = ( data.years[0] > 1980 ?  data.years[0] : 1980 ) + ' - ' + ( parseInt(data.years[1]) > 0 ? parseInt(data.years[1]) : 2018 );
		}
	}

	// Handle CC Updates
	if ( data.cc && 'undefined' !== typeof data.cc ) {
		var cc_slider = document.getElementById( 'zablisting_cc_filter' );
		if ( ! isEmpty( cc_slider ) ) {
			cc_slider.noUiSlider.updateOptions( {
				start: [ data.cc[0], data.cc[1] ],
				range: {
					'min': [  data.cc[0] ],
					'max': [ data.cc[1] ]
				},
			} );
			document.getElementById( 'zablisting_cc_filter_indicator' ).innerText = data.cc[0] + 'cc - ' + data.cc[1] + 'cc';
		}
	}

	// Handle Colour Updates
	if ( data.colors && 'undefined' !== typeof data.colors ) {
		jQuery( '[data-colour-filter]' ).each( function( i, o ) {
			jQuery( o ).css( 'display', 'none' );
			if( data.colors.indexOf( jQuery( o ).data( 'colour-filter' ) ) > -1 ) {
				jQuery( o ).css( 'display', 'inline-block' );
			}
		} );
	}

	// Handle New/Used Updates
	if ( data.new_used && 'undefined' !== typeof data.new_used ) {

		jQuery( 'select[name="zab-filter-new-used"] option' ).remove();

		newOption = new Option( 'All', 'all', false, false );
		jQuery( 'select[name="zab-filter-new-used"]' ).append( newOption );

		for (i = 0; i < data.new_used.length; i++ ) {
			newOption = new Option( data.new_used[ i ], data.new_used[ i ], false, ( 'undefined' !== typeof window.zabListings.filteredNewUsed.items[0] && data.new_used[ i ] === window.zabListings.filteredNewUsed.items[0] ) );
			jQuery( 'select[name="zab-filter-new-used"]' ).append( newOption );
		}

		jQuery( 'select[name="zab-filter-new-used"]' ).trigger( 'change' );

	}

	// Handle Location Updates
	if ( data.locations && 'undefined' !== typeof data.locations ) {

		jQuery( 'select[name="zab-filter-location"] option' ).remove();

		newOption = new Option( 'All', 'all', false, false );
		jQuery( 'select[name="zab-filter-location"]' ).append( newOption );

		for ( i = 0; i < data.locations.length; i++ ) {
			newOption = new Option( data.locations[ i ], data.locations[ i ], false, ( 'undefined' !== typeof window.zabListings.filteredLocation.items[0] && data.locations[ i ] === window.zabListings.filteredLocation.items[0] ) );
			jQuery( 'select[name="zab-filter-location"]' ).append( newOption );
		}

		jQuery( 'select[name="zab-filter-location"]' ).trigger( 'change' );

	}

};

window.zabBusinessListings = new Vue( {
	el: '#all-businesses-search',
	data: {
		isLoading: true,
		hasFiltered: false,
		filtersPanelExpanded: false,
		listings: [],
		storedQueryString: '',
		gridLayout: true,
		order: 'asc',
		page: 1,
		totalPages: 1,
		resultsCount: 0,
		resultsFrom: 1,
		resultsTo: 0,
		filteredCategory: {
			name: 'business-category',
			items: []
		},
		filteredLocation: {
			name: 'business-location',
			items: []
		},
		filterOrder: 'random',
		hasOverriddenFilterOrder: false,
		custom_per_page: 30,
		context: 'business_listing',
		query: {
			data: {
				per_page: 30,
				order: 'asc',
				customer_orderby: 'title',
				listorder: 'newest-first',
				custom_context: 'business_listings'
			}
		}
	},

	created() {
		window.onpopstate = this.doPopState;
		this.newGetQueryParams();
	},

	mounted() {
		this.newGetQueryParams();
		this.doApiCall();
		this.hasDoneFiltering();
	},

	computed: {
		filteredListings() {
			return this.listings;
		}
	},

	methods: {

		doApiCall( isButtonTrigger = false ) {

			this.setQueryData();

			wp.api.loadPromise.done( function() {
				listingCollection = new wp.api.collections.Users();
			} ).then( () => {
				if ( isButtonTrigger ) {
					this.setQueryStringParams();
				} else {
					this.apiQuery();
				}
			} );
		},

		doApiCallToBusinessDirectory() {
			this.setQueryData();
			console.log( window.business_directory_url + this.buildQueryStringParams() );
			window.location = window.business_directory_url + this.buildQueryStringParams();
		},

		hasDoneFiltering() {
			// if any of the filtered data objects have items
			// then we've done some filtering, so set
			// hasFiltered to true
			if (
				this.filteredCategory.items.length ||
				this.filteredLocation.items.length
			) {
				this.hasFiltered = true;
			} else {
				this.hasFiltered = false;
			}
		},

		newGetQueryParams() {
			const parsedURL = queryString.parse(location.search);
			for (let key in parsedURL) {
				let value = parsedURL[key];
				value = value.split(',');
				this.vueifyQueryParams(key, value);
			}
		},
		/**
		 * Takes a key / value pair and adds it to
		 * its associated Vue data property
		 **/
		vueifyQueryParams(key, value) {
			switch (key) {
				case 'filter-business-category':
					value.forEach( id => this.filteredCategory.items.push( id ) );
					break;
				case 'filter-business-location':
					value.forEach(id =>
						this.filteredLocation.items.push( id )
					);
					break;
			}
		},

		apiQuery() {
			this.isLoading = true;
			this.setQueryData();
			listingCollection.fetch( this.query ).done( this.parseData );
		},

		setQueryData() {
			// get all filterable lists from Vue's data object
			const filterableLists = [
				this.filteredCategory,
				this.filteredLocation
			];
			// remove all tax querys and add according to the set filtered data.
			filterableLists.forEach(filterableList => {
				delete this.query.data[filterableList.name];
				if (filterableList.items.length) {
					this.query.data[filterableList.name] = filterableList.items;
				}
			});
			this.query.data.page = this.page;
			this.query.data.order = this.order;
			this.query.data.per_page = this.custom_per_page;

			// Defaults the listing order to highest price on page load if make is set in URL.
			if ( this.filteredCategory.items.length > 0 && ! this.hasOverriddenFilterOrder ) {
				this.query.data.listorder = 'latest';
			}
		},

		parseData( response ) {
			document.body.scrollTop = document.documentElement.scrollTop = 0;
			if ( 'undefined' !== response.filterSettings ) {
				//handleFilterUpdates( response.filterSettings );
			}
			this.listings = response;
			this.totalPages = listingCollection.state.totalPages;
			this.resultsCount = listingCollection.state.totalObjects;
			this.resultsFrom = listingCollection.state.currentPage;
			if ( listingCollection.state.currentPage > 1 ) {
				this.resultsFrom = ( listingCollection.state.currentPage - 1 ) * this.query.data.per_page + 1;
			}
			this.resultsTo = ( this.page === this.totalPages ? this.resultsCount : this.page * this.query.data.per_page );
			this.isLoading = false;
		},

		buildQueryStringParams() {
			// get all filterable lists from Vue's data object
			const filterableLists = [
				this.filteredCategory,
				this.filteredLocation
			];

			// Reset storedQueryString to and re-add filtered items each time we run this function
			this.storedQueryString = '';

			let tempQueryString = '';

			// FirstRun gets a ?, subsequent runs get an &
			let join = '?';

			// loop over each filterable list and add any items in its array
			filterableLists.forEach( filterableList => {
				if ( filterableList.items.length ) {
					tempQueryString =
						join +
						'filter-' +
						filterableList.name +
						'=' +
						filterableList.items.toString();
					join = '&';
					this.storedQueryString += tempQueryString;
				}
				// Concat storedQueryString as we loop over the filterable lists
			} );

			// Set Order and Pagination
			this.storedQueryString += join + 'filter-order=' + this.order;
			this.storedQueryString += '&filter-page=' + this.page;

			return this.storedQueryString;

		},

		setQueryStringParams( context = '' ) {
			if ( 'userSetOrderBy' === context ) {
				this.hasOverriddenFilterOrder = true;
			}
			// get all filterable lists from Vue's data object
			const filterableLists = [
				this.filteredCategory,
				this.filteredLocation
			];

			// Reset storedQueryString to and re-add filtered items each time we run this function
			this.storedQueryString = '';

			let tempQueryString = '';

			// FirstRun gets a ?, subsequent runs get an &
			let join = '?';

			// loop over each filterable list and add any items in its array
			filterableLists.forEach( filterableList => {
				if ( filterableList.items.length ) {
					tempQueryString =
						join +
						'filter-' +
						filterableList.name +
						'=' +
						filterableList.items.toString();
					join = '&';
					this.storedQueryString += tempQueryString;
				}
				// Concat storedQueryString as we loop over the filterable lists
			} );

			// Set Order and Pagination
			this.storedQueryString += join + 'filter-order=' + this.order;
			this.storedQueryString += '&filter-page=' + this.page;

			this.apiQuery();

			// Scroll back to top when you filter
			//document.documentElement.scrollTop = 0;

			if ( !isEmpty( this.storedQueryString ) ) {
				history.pushState( {}, false, this.storedQueryString );
			} else {
				let pageUrl = window.location.href.split( '?' );
				history.pushState( {}, false, pageUrl[0] );
			}

			this.hasDoneFiltering();
		},

		toggleChildrenFiltersOpen( e ) {
			const targetFilter = e.target.parentNode.querySelector(
				'.listing-sidebar-filters'
			);

			toggleAttribute( targetFilter, 'aria-expanded' );
		},

		doPopState() {
			this.resetSearch( false );
			this.newGetQueryParams();
			this.apiQuery();
		},

		resetSearch( clearQueryString = true ) {
			this.resetListingFilters();
			// empty all filterable lists
			if ( clearQueryString ) {
				this.setQueryStringParams();
			}
		},

		resetListingFilters() {
			this.filteredCategory.items = [];
			this.filteredLocation.items = [];

			this.order = 'asc';
			this.page = 1;
			this.$refs.paginate.selected = 0;

		},

		paginationHandler( page ) {
			this.page = page;
			this.setQueryStringParams();
		}
	},
	filters: {
		capitalize( value ) {
			if ( !value ) {
				return '';
			}
			value = value.toString();
			return value.charAt( 0 ).toUpperCase() + value.slice( 1 );
		}
	}
} );

/* ----- */

var handleYearSlider = document.getElementById( 'zablisting_year_filter' );

if ( ! isEmpty( handleYearSlider ) ) {

	noUiSlider.create( handleYearSlider, {
		start: [ 1985, 2018 ],
		range: {
			'min': [  1985 ],
			'max': [ 2018 ]
		},
		step: 1,
		connect: true
	});

	document.getElementById( 'zablisting_year_filter_indicator' ).innerText = '1985 - 2018';

	handleYearSlider.noUiSlider.on( 'slide', function( e ){
		document.getElementById( 'zablisting_year_filter_indicator' ).innerText = parseInt(e[0]).toFixed() + ' - ' + parseInt( e[1] ).toFixed();
		window.zabListings.filteredYears.items = [ parseInt(e[0]).toFixed(), parseInt(e[1]).toFixed() ];
	} );

}

/* ----- */

var handleMileageSlider = document.getElementById( 'zablisting_mileage_filter' );

if ( ! isEmpty( handleMileageSlider ) ) {

	noUiSlider.create(handleMileageSlider, {
		start: [0, 200000],
		range: {
			'min': [0],
			'max': [200000]
		},
		step: 1000,
		connect: true
	});

	document.getElementById(
		'zablisting_mileage_filter_indicator').innerText = '0km - 200,000km';

	handleMileageSlider.noUiSlider.on('slide', function(e) {
		document.getElementById(
			'zablisting_mileage_filter_indicator').innerText = parseInt(e[0]).
			toFixed() + 'km - ' + parseInt(e[1]).toFixed() + 'km';
		window.zabListings.filteredMileage.items = [
			parseInt(e[0]).toFixed(),
			parseInt(e[1]).toFixed()];
	});

}

/* ----- */

var handleCcSlider = document.getElementById( 'zablisting_cc_filter' );

if ( ! isEmpty( handleCcSlider ) ) {

	noUiSlider.create(handleCcSlider, {
		start: [50, 1300],
		range: {
			'min': [50],
			'max': [1300]
		},
		step: 100,
		connect: true
	});

	document.getElementById(
		'zablisting_cc_filter_indicator').innerText = '50cc - 1300cc';

	handleCcSlider.noUiSlider.on('slide', function(e) {
		document.getElementById(
			'zablisting_cc_filter_indicator').innerText = parseInt(e[0]).toFixed() +
        'cc - ' + parseInt(e[1]).toFixed() + 'cc';
		window.zabListings.filteredCapacity.items = [
			parseInt(e[0]).toFixed(),
			parseInt(e[1]).toFixed()];
	});

}

/* ----- */

var handlePriceSlider = document.getElementById( 'zablisting_price_filter' );

if ( ! isEmpty( handlePriceSlider ) ) {

	noUiSlider.create(handlePriceSlider, {
		start: [window.listingPrices.min, window.listingPrices.max],
		range: {
			'min': [window.listingPrices.min],
			'max': [window.listingPrices.max],
		},
		step: 1000,
		connect: true
	});

	document.getElementById('zablisting_price_filter_indicator').innerText = 'R' +
      window.listingPrices.min + ' - R' + window.listingPrices.max;

	handlePriceSlider.noUiSlider.on('slide', function(e) {
		document.getElementById(
			'zablisting_price_filter_indicator').innerText = 'R' +
        parseInt(e[0]).toFixed() + ' - R' + parseInt(e[1]).toFixed();
		window.zabListings.filteredPrice.items = [
			parseInt(e[0]).toFixed(),
			parseInt(e[1]).toFixed()];
	});

}

/* ----- */

var colourFilterIcons = document.querySelectorAll( '.listings-filter__container__column__control__colour_filter' );
var targetCheckbox;

for ( var i = 0; i < colourFilterIcons.length; i++ ) {
	colourFilterIcons[i].addEventListener( 'click', function ( e ) {
		e.target.classList.toggle( 'active' );
		targetCheckbox = e.target.querySelectorAll( 'input[type="checkbox"]' );
		if ( targetCheckbox[0].getAttribute( 'checked' ) ) {
			targetCheckbox[0].removeAttribute( 'checked' );
		} else {
			targetCheckbox[0].setAttribute( 'checked', true );
		}
		targetCheckbox[0].click();
	} );
}
